export { SearchTranscript } from './search-transcript';
export type { SearchTranscriptProps } from './search-transcript';
